<template>
  <div class="content content--sub">
    <OverlayLoader v-if="!$store.getters.clientsLoaded"></OverlayLoader>
    <div class="bg-img">
      <img src="../../assets/images/hero-company.jpg">
    </div>

    <MyHeader :breadcrumbItems="[
        {
          name: section.name,
          path: `/${$route.params.companySlug}/clients`
        },
      ]"/>

    <header class="content-header">
      <h1>{{ section.name }}</h1>
    </header>

    <div class="container main-content">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="filters">
            <div class="filters-header">
              <span class="filters-title">Filters</span>
              <button class="link filters-clear" @click="clearAll()"><span>Clear all</span></button>
            </div>
            <div class="filters-group" v-if="clientCategories.length">
              <span class="filters-subtitle">Client type</span>
              <div class="form-block-checkboxes">
                <label v-for="client in clientCategories" :key="client.idSettingCompany">
                  <input :id="client.idSettingCompany"  name="client" type="radio" :value="client" v-model="filters.category">
                  <span>{{ client.value }} </span>
                </label>
              </div>
            </div>
            <div class="filters-group" v-if="sectors.length">
              <span class="filters-subtitle">Sector</span>
              <div class="form-block-checkboxes">
                <label v-for="sector in sectors" :key="sector.idSettingCompany">
                  <input :id="sector.idSettingCompany"  name="sector" type="radio" :value="sector" v-model="filters.sector">
                  <span>{{ sector.value }} </span>
                </label>
              </div>
            </div>
            <div class="filters-group" v-if="countries.length">
              <span class="filters-subtitle">Country</span>
              <div class="form-block-checkboxes">
                <label v-for="country in countries" :key="country.idSettingCompany">
                  <input :id="country.idSettingCompany"  name="country" type="radio" :value="country" v-model="filters.country">
                  <span>{{ country.value }} </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-9 article-content">
          <div class="section-header">
            <form class="form--oneliner">
              <div class="input-wrapper">
                <input type="text" v-model="search" placeholder="Search...">
              </div>
              <button @click.prevent><i class="icon-search"></i></button>
            </form>
          </div>
          <div class="mobile-filters d-lg-none">
            <button class="link-icon link--filter" @click="showMenuFilter = true">
              <i class="icon-filter"></i>
              Filter
            </button>

            <transition name="fade">
              <div class="window-nav" v-if="showMenuFilter">
                <div class="window-nav-inner">
                  <div class="window-nav-top">
                    <button class="window-nav-close" @click="showMenuFilter = false"><i class="icon-chevron-b"></i></button>
                    Filter and Sort
                  </div>

                  <div class="window-nav-checkboxes" v-if="clientCategories.length">
                    <div class="window-nav-title">
                      <span>Client type</span>
                      <button class="window-filters-clear" @click="clearAll()"><span>Clear all</span></button>
                    </div>

                    <div class="form-block-checkboxes" v-if="clientCategories.length">
                      <label v-for="client in clientCategories" :key="client.idSettingCompany">
                        <input :id="client.idSettingCompany"  name="client" type="radio" :value="client" v-model="filters.category">
                        <span>{{ client.value }} </span>
                      </label>
                    </div>

                    <div class="window-nav-title"  v-if="sectors.length">
                      <span>Sectors</span>
                    </div>

                    <div class="form-block-checkboxes" v-if="sectors.length">
                      <label v-for="sector in sectors" :key="sector.idSettingCompany">
                        <input :id="sector.idSettingCompany"  name="sector" type="radio" :value="sector" v-model="filters.sector">
                        <span>{{ sector.value }} </span>
                      </label>
                    </div>

                    <div class="window-nav-title"  v-if="countries.length">
                      <span>Country</span>
                    </div>

                    <div class="form-block-checkboxes" v-if="countries.length">
                      <label v-for="country in countries" :key="country.idSettingCompany">
                        <input :id="country.idSettingCompany"  name="country" type="radio" :value="country" v-model="filters.country">
                        <span>{{ country.value }} </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <ClientGrid :boxes="clients"></ClientGrid>

          <div class="buttons" v-if="isNotFullContentLoaded && $store.getters.clientsLoaded">
            <button @click="loadMore" class="button">Show 200 more results</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import OverlayLoader from "@/components/general/OverlayLoader";
import settings from "@/settings";
import ClientGrid from "@/components/clients/ClientGrid";

export default {
  name: "Clients",
  components: {ClientGrid, OverlayLoader, MyHeader},
  data () {
    return {
      showList: false,
      filters: {
        sort:  {
          id: 0,
          name: 'Recently added',
          value: 'name'
        },
        category: {},
        country: {},
        sector: {},
        page: 1,
        per_page: 200,
        search: "",
      },
      page: 1,
      search: '',
      showMenuFilter: false,
    }
  },
  computed: {
    isNotFullContentLoaded() {
      return this.$store.getters.clientsMetaInfo._lastPage && this.page < this.$store.getters.clientsMetaInfo._lastPage
    },
    clients() {
      if(this.search) {
        return this.$store.getters.clients.filter(item => {
          return item.name.toUpperCase().includes(this.search.toUpperCase())
        });
      }
      return this.$store.getters.clients;
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === this.$route.name
      })
    },
    countries() {
      let usedCountries = this.$store.getters.wholeClients.map(item => item.idCountry)
      return this.$store.getters.countries.filter(item => {
        return usedCountries.includes(item.idSettingGlobal)
      });
    },
    clientCategories() {
      return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.CLIENT_CATEGORIES);
    },
    sectors() {
      return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.SECTORS);
    }
  },
  mounted() {
    this.getClients();
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.getClients()
      }
    },
    '$store.getters.clientsLoaded' (val) {
      if(val) {
        window._paq.push(['setDocumentTitle', this.section.name]);
        window._paq.push(['trackPageView']);
      }
    }
  },
  methods: {
    getClients(clean = true) {
      if(clean) {
        this.page = 1;
        this.$store.dispatch('cleanClients')
      }
      let params = {
        _embed: 1,
        _page: this.page,
        _per_page: this.filters.per_page,
        _sort: this.filters.sort.value
      }
      if(this.filters.category && this.filters.category.idSettingCompany) {
        params.idCategory = this.filters.category.idSettingCompany
      }
      if(this.filters.sector && this.filters.sector.idSettingCompany) {
        params.idSector = this.filters.sector.idSettingCompany
      }
      if(this.filters.country && this.filters.country.idSettingGlobal) {
        params.idCountry= this.filters.country.idSettingGlobal
      }
      // if(this.filters.search) {
      //   params._query = this.filters.search
      // }
      this.$store.dispatch('getClients', params);
    },
    loadMore() {
      this.page += 1;
      if (this.isNotFullContentLoaded) {
        this.getClients(false)
      }
    },
    clearAll() {
      this.filters = {
        sort:  {
          id: 0,
            name: 'Recently added',
            value: 'name'
        },
        category: {},
        country: {},
        sector: {},
        page: 1,
        per_page: 200
      }
    },
  }
}
</script>
